import { useCallback, useState } from "react";
import styles from "./styles.module.scss";

export default function YouTubeVideo({ id, time = 0 }: { id: string, time: number }) {
	const videoWithTimestamp = `${id}?start=${time}`;
	const [clicked, setClicked] = useState<boolean>(false);

	const onClick = useCallback(() => {
		setClicked(true);
	}, []);

	return (
		<div className="customContainer">
			<div className="row fullBleedImage">
				<div className="col s12">
					<div className="item-video">
						{!clicked &&
							<button className={styles.button} onClick={onClick}>
								<img className={styles.img} src="/roadsync/video-roadsync.jpg" onClick={onClick} />
							</button>}
						{clicked &&
							<iframe
								className="youtubeVideo"
								width="1377"
								height="775"
								src={`https://www.youtube.com/embed/${videoWithTimestamp}&rel=0&showinfo=0&controls=0&modestbranding=0`}
								frameBorder="0"
								allowFullScreen
							></iframe>}
					</div>
				</div>
			</div>
		</div>
	);
}
